import { GeneralStepConversationTopics, SharePermissions, TicketStages } from 'core/enums/common';

import { IPermissionsInfo, IStagesInfo, IStagesInput, ISubStagesInfo } from './types';

export const allStagesEnum = Object.values(TicketStages).filter(
	(item) => typeof item === 'string'
).length;

export const allSubStagesEnum = Object.values(GeneralStepConversationTopics).filter(
	(item) => typeof item === 'string'
).length;

export const permissionsInfo: Array<IPermissionsInfo> = [
	{
		permissionEnum: SharePermissions.Read,
		label: 'read',
	},
	{
		permissionEnum: SharePermissions.Write,
		label: 'write',
	},
	{
		permissionEnum: SharePermissions.Manage,
		label: 'manage',
	},
];

export const getStagesInfo = ({
	isUseCasesReady,
	isTestCasesReady,
	isNotificationsReady,
	isReportReady,
}: IStagesInput): Array<IStagesInfo> => {
	return [
		{
			stageEnum: TicketStages.general,
			label: 'generalStep',
			isAvailable: true,
		},
		{
			stageEnum: TicketStages.useCases,
			label: 'useCasesStep',
			isAvailable: isUseCasesReady,
		},
		{
			stageEnum: TicketStages.testCases,
			label: 'testCasesStep',
			isAvailable: isTestCasesReady,
		},
		{
			stageEnum: TicketStages.notifications,
			label: 'notificationsStep',
			isAvailable: isNotificationsReady,
		},
		{
			stageEnum: TicketStages.report,
			label: 'reportStep',
			isAvailable: isReportReady,
		},
		{
			stageEnum: allStagesEnum,
			label: 'all',
			isAvailable: true,
		},
	];
};

export const subStagesInfo: Array<ISubStagesInfo> = [
	{
		subStageEnum: GeneralStepConversationTopics['Functional requirements'],
		label: 'Functional requirements',
	},
	{
		subStageEnum: GeneralStepConversationTopics['Performance'],
		label: 'Performance',
	},
	{
		subStageEnum: GeneralStepConversationTopics['Scalability'],
		label: 'Scalability',
	},
	{
		subStageEnum: GeneralStepConversationTopics['Portability and compatibility'],
		label: 'Portability and compatibility',
	},
	{
		subStageEnum: GeneralStepConversationTopics['Reliability'],
		label: 'Reliability',
	},
	{
		subStageEnum: GeneralStepConversationTopics['Maintainability'],
		label: 'Maintainability',
	},
	{
		subStageEnum: GeneralStepConversationTopics['Availability'],
		label: 'Availability',
	},
	{
		subStageEnum: GeneralStepConversationTopics['Security'],
		label: 'Security',
	},
	{
		subStageEnum: GeneralStepConversationTopics['Usability'],
		label: 'Usability',
	},
	{
		subStageEnum: allSubStagesEnum,
		label: 'all',
	},
];
